

import React, { memo } from 'react';

import cx from 'classnames';
import { LABEL, LABEL_CONTAINER, LABEL_HEADER, HELPER } from '../styles/labelWrapper';
import Text from '../../Text';

import { LABEL_POSITION } from '../constants/labelPosition';





















/**
 * A component that renders an Input child inside a label
 *
 * @param {LabelWrapperProps} props
 *
 * @return {React.Element}
 */
function LabelWrapper({
  children,
  className,
  label,
  subLabel,
  id,
  extraLabelContent,
  disabled,
  helper,
  prefixDagger,
  prefixDoubleDagger,
  suffixDagger,
  suffixDoubleDagger,
  required,
  divContainer,
  notFullWidth,
  position = LABEL_POSITION.TOP,
  heading5 = false
}) {
  if (!label && !helper && !subLabel) {return children;}

  const labelChild =
  <>
      <div className={LABEL_HEADER}>
        {
      label &&
      <Text
        className={LABEL}
        label
        noMargin={subLabel ? 'bottom' : void 0}
        prefixDagger={prefixDagger}
        prefixDoubleDagger={prefixDoubleDagger}
        suffixDagger={suffixDagger}
        suffixDoubleDagger={suffixDoubleDagger}
        required={required}
        heading5={heading5}>

              {label}
            </Text>}


        {extraLabelContent || null}
      </div>
      {subLabel &&
    <Text disabled={disabled} caption>{subLabel}</Text>}

      {children}
      {helper && <Text className={HELPER} disabled={disabled} caption>{helper}</Text>}
    </>;


  if (divContainer) {
    return (
      <div className={cx(LABEL_CONTAINER({ notFullWidth, position }), className)}>{labelChild}</div>);

  }

  return (
    // ID comes from props as a required field but eslint won't pick that up
    // eslint-disable-next-line jsx-a11y/label-has-for
    <label className={cx(LABEL_CONTAINER({ notFullWidth, position }), className)} htmlFor={id}>
      {labelChild}
    </label>);

}

export default memo(LabelWrapper);